import React from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Stack,
  Typography,
} from "@mui/material";
import { UploadSession } from "../types/configurableUpload";

interface UploadStatusPanelProps {
  sessions: UploadSession[];
  onDismiss: (id: string) => void;
}

const stateColor = (state: UploadSession["state"]) => {
  switch (state) {
    case "success":
      return "success";
    case "timeout":
    case "error":
      return "warning";
    default:
      return "info";
  }
};

const UploadStatusPanel: React.FC<UploadStatusPanelProps> = ({
  sessions,
  onDismiss,
}) => {
  if (sessions.length === 0) {
    return null;
  }

  return (
    <Box sx={{ width: "100%", maxWidth: 960, mx: "auto", mt: 2 }}>
      <Stack spacing={1.5}>
        {sessions.map((session) => (
          <Card key={session.id} variant="outlined">
            <CardContent
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: { xs: "stretch", md: "center" },
                gap: 2,
              }}
            >
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="subtitle1" noWrap>
                  {session.fileName}
                </Typography>
                <Alert severity={stateColor(session.state)} sx={{ mt: 1 }}>
                  {session.message}
                </Alert>
              </Box>
              <Chip
                label={session.state}
                color={stateColor(session.state)}
                variant="outlined"
                sx={{ alignSelf: { xs: "flex-start", md: "center" } }}
              />
              <Button onClick={() => onDismiss(session.id)} size="small">
                Dismiss
              </Button>
            </CardContent>
          </Card>
        ))}
      </Stack>
    </Box>
  );
};

export default UploadStatusPanel;
